import { UserDetail } from 'components/user/user-detail/UserDetail'
import { useEffect } from 'react'
import { TabProfileContainer } from './tab-profile/TabProfileContainer'
import { TabAddressContainer } from './tab-address/TabAddressContainer'
import { TabOrderContainer } from './tab-order/TabOrderContainer'
import { TabPointContainer } from './tab-point/TabPointContainer'
import { TabReviewContainer } from './tab-review/TabReviewContainer'
import { TabBeautyProfileContainer } from './tab-beauty-profile/TabBeautyProfileContainer'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { TabWishlistContainer } from './tab-wishlist/TabWishlistContainer'
import { TabWaitlistContainer } from './tab-waitlist/TabWaitlistContainer'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from 'reducers/userReducer'

const USER_TABS = ['profile', 'alamat', 'pesanan', 'poin', 'review', 'beauty profile', 'wishlist', 'waitlist']

export const UserDetailContainer = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const userId = searchParams.get('userId')
    const tabName = searchParams.get('tabName')
    const { data, fetching: getUserDetailApi, isLoading } = useFetch({ ...API_USER.DETAILS, initPathVariable: userId })
    const { isReload } = useSelector((state) => state.userReducer)

    useEffect(() => {
        getUserDetailApi().then((res) => dispatch(setUserDetails(res?.data)))
    }, [isReload])

    const content = {
        profile: <TabProfileContainer isLoading={isLoading} />,
        alamat: <TabAddressContainer id={userId} />,
        pesanan: <TabOrderContainer id={userId} />,
        poin: <TabPointContainer id={userId} />,
        review: <TabReviewContainer id={userId} />,
        'beauty profile': <TabBeautyProfileContainer id={userId} />,
        wishlist: <TabWishlistContainer id={userId} />,
        waitlist: <TabWaitlistContainer id={userId} />,
    }

    const setActiveTabHandler = (item) => {
        navigate(`/user/user-list/user-detail?tabName=${item}&userId=${userId}`)
    }

    const props = {
        dataTabs: USER_TABS,
        activeTab: tabName || 'profile',
        setActiveTabHandler,
        content,
        userDetail: data?.data,
        isLoading,
    }

    return <UserDetail {...props} />
}
